/**
 * Dashboard Feature Routes — Donor Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Dashboard',
      breadcrumbs: [{ label: 'nav.dashboard' }],
    },
  },
];
